export default __webpack_public_path__ + "static/media/back-arrow.fa0e2de8.svg";